import $http from '@/api';

const getStaffNotifications = (): Promise<StaffNotification[]> => $http.get('/api/staff/notifications');
const deleteStaffNotifications = () => $http.delete('/api/staff/notifications');
const deleteStaffNotification = (notificationId: StaffNotificationId) => $http.delete(`/api/staff/notifications/${notificationId}`);
const readNotifications = (notificationIds: StaffNotificationId[]) => $http.post('/api/staff/notifications/read', { notificationIds });
const unreadNotifications = (notificationIds: StaffNotificationId[]) => $http.post('/api/staff/notifications/unread', { notificationIds });
const pinNotification = (notificationId: StaffNotificationId): Promise<StaffNotification> => $http.post(`/api/staff/notifications/${notificationId}/pin`);
const unpinNotification = (notificationId: StaffNotificationId): Promise<StaffNotification> => $http.post(`/api/staff/notifications/${notificationId}/unpin`);

export default {
  getStaffNotifications,
  deleteStaffNotifications,
  deleteStaffNotification,
  readNotifications,
  unreadNotifications,
  pinNotification,
  unpinNotification,
};
